import { Modal, Box, Typography, IconButton } from "@mui/material";
import { MainTable } from "components";
import { useRCAMainStyles } from "pages/Corporate/RCA/RCA.styles";
import { IMainTableColumn } from "components/MainTable/MainTableInterfaces";
import RCAIcon from "pages/Corporate/RCA/images/rca_icon.svg";
import { useTranslation } from "react-i18next";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import CloseIcon from "@mui/icons-material/Close";
import { CORPORATE_BACKOFFICE_PATHS } from "constants/constants";
import { useNavigate } from "react-router-dom";
import { IModalRCAWithNoMethodologyUsedSettings } from "./IModalRCAWithNoMethodologyUsedSettings";
import { useStyles } from "./RCAWithNoMethodologyUsedModal.styles";

interface IRcaNoMethodologyUsedColumn extends Omit<IMainTableColumn, "render"> {
    render: (row: number) => string | JSX.Element | number;
}

const RCAWithNoMethodologyUsedModal = ({ open, handleClose, data }: IModalRCAWithNoMethodologyUsedSettings) => {
    const navigate = useNavigate();
    const classes = useStyles();
    const mainClasses = useRCAMainStyles();
    const { t } = useTranslation();
    const tableColumns: IRcaNoMethodologyUsedColumn[] = [
        {
            id: "rca_id",
            label: t("rca.compliance.rca_compliance.rca_methodology_used.rca"),
            hideSortIcon: true,
            render: (row: number) => <div className={classes.descriptionWrapper}>
                <img src={RCAIcon} alt="RCA icon" />
                <span>{`${t("rca.rca")}-${row}`}</span>
            </div>
        }
    ];
    
    return (
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            className={classes.modal}
        >
            <Box className={classes.modalContent}>
                <div>
                    <Typography variant="h6" className={classes.modalTitle}>
                        {t("rca.compliance.rca_compliance.rca_methodology_used.modalTitle")}
                        <IconButton onClick={() => handleClose()}>
                            <CloseIcon />
                        </IconButton>
                    </Typography>
                </div>
                <div className={classes.modalBody}>
                    <div className={classes.userNameContainer}>
                        {data?.media_url ? (
                            <img src={data?.media_url} alt={`${data?.first_name} ${data?.last_name}`} className={classes.userImage} />
                        ) : (
                            <AccountCircleIcon className={classes.userImage} />
                        )}
                        {data?.first_name} {data?.last_name}
                        <span className={classes.percentageDetail}>{data?.none_percentage}% ({data?.none_methodology_rca_list.length} {t("rca.compliance.rca_compliance.rca_methodology_used.rca")})</span>
                    </div>
                    <div className={mainClasses.contentWrapper}>
                        <div style={{ padding: 5.5 }} className={`${mainClasses.contentCard}`}>
                            <MainTable
                                maxHeight={false}
                                customStyle={`${mainClasses.contentTable}`}
                                paperElevation={0}
                                paperCustomStyle={mainClasses.contentTablePaper}
                                columns={tableColumns as IMainTableColumn[]}
                                tableCellCustomStyle={mainClasses.contentTableCell}
                                tableExpandedRowCustomStyle={mainClasses.contentTableExpandedRow}
                                rows={data?.none_methodology_rca_list || []}
                                onRowClick={(row: any) => {
                                    navigate(
                                        `/${CORPORATE_BACKOFFICE_PATHS.ROOT_PATH}/${CORPORATE_BACKOFFICE_PATHS.RCA.ROOT}/${CORPORATE_BACKOFFICE_PATHS.RCA.RCA_LIBRARY.ROOT}/${row}`,
                                        {
                                            state: {
                                                from: `/${CORPORATE_BACKOFFICE_PATHS.ROOT_PATH}/${CORPORATE_BACKOFFICE_PATHS.RCA.ROOT}/${CORPORATE_BACKOFFICE_PATHS.RCA.RCA_LIBRARY.ROOT}`,
                                            },
                                        },
                                    );
                                }}
                            />
                        </div>
                    </div>
                </div>
            </Box>
        </Modal>
    );
};

export default RCAWithNoMethodologyUsedModal;